// Dynamically load the Google Maps API here.
// Doing so this way should allow the map to work in both App and Cypress.
export function mapApiDynamicLoad() {
    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD2CBKukgJYmnXqSXLGS94u8h6Jkvu3Ol4&libraries=places&v=quarterly';
    script.async = true;
    document.head.appendChild(script);
}